import React from 'react';
import { Calendar, Clock, MapPin } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
import { Link } from 'react-router-dom';

interface EventCardProps {
  id: number;
  title: string;
  date: string;
  time: string;
  location: string;
  description: string;
  imageUrl: string;
  timestamp: number;
  stripeLink?: string;
}

export const EventCard: React.FC<EventCardProps> = ({
  id,
  title,
  date,
  time,
  location,
  description,
  imageUrl,
  timestamp,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <div className="relative h-64">
        <img
          src={imageUrl}
          alt={title}
          className="w-full h-full object-contain bg-gray-50"
        />
        <div className="absolute top-4 right-4">
          <CountdownTimer 
            targetDate={timestamp}
            className="bg-white/90 backdrop-blur-sm text-primary-600 px-4 py-2 rounded-full shadow-lg font-medium"
          />
        </div>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-semibold mb-2">{title}</h3>
        <div className="space-y-2 mb-4">
          <div className="flex items-center text-gray-600">
            <Calendar className="h-5 w-5 mr-2" />
            <span>{date}</span>
          </div>
          <div className="flex items-center text-gray-600">
            <Clock className="h-5 w-5 mr-2" />
            <span>{time}</span>
          </div>
          <div className="flex items-center text-gray-600">
            <MapPin className="h-5 w-5 mr-2" />
            <span>{location}</span>
          </div>
        </div>
        <p className="text-gray-600 mb-4">{description}</p>
        <div className="flex justify-end">
          <Link
            to={`/payment/${id}`}
            className="bg-primary-600 text-white px-6 py-2 rounded-md hover:bg-primary-700 transition-colors"
          >
            Réserver
          </Link>
        </div>
      </div>
    </div>
  );
};